import React, { useContext, useEffect, useState } from 'react';
import { StyleSheet, PDFViewer } from '@react-pdf/renderer';
import axios from 'axios';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import BreadCrumb from '../../../../../Components/BreadCrumb/BreadCrumb';
import LoadingSpinner from '../../../../../Components/LoadingSpinner';
import LanguageContext from '../../../../../context/LanguageContext';
import BmiListPdfFile from './BmiListPdfFile';

const viewerStyle = StyleSheet.create({
  viewer: {
    width: '90%',
    height: '100%',
    minHeight: 800,
    margin: 'auto',
  },
});

const BmiListPdfDocument = () => {
  const location = useLocation();
  const intl = useIntl();
  const { defaultLanguage } = useContext(LanguageContext);
  const isBn = defaultLanguage === 'bn';
  const filters = location.state || {};
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!filters.institution_id || !filters.grade) {
      setLoading(false);
      setError(intl.formatMessage({ id: 'selectClass' }));
      return;
    }

    const fetchList = async () => {
      setLoading(true);
      try {
        const token = JSON.parse(localStorage.token);
        const params = new URLSearchParams({
          institution_id: filters.institution_id,
          grade: filters.grade,
          academic_year: filters.academic_year || new Date().getFullYear(),
          pagination_limit: 1000,
        });
        if (filters.section_id) {
          params.append('section_id', filters.section_id);
        }
        if (filters.round) {
          params.append('round', filters.round);
        }
        if (filters.shift_id) {
          params.append('shift_id', filters.shift_id);
        }

        const response = await axios.get(`${process.env.REACT_APP_API_URL}bmi/participated/list?${params.toString()}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setStudents(Array.isArray(response.data?.data) ? response.data.data : []);
        setError('');
      } catch (err) {
        setError(err?.response?.data?.message || intl.formatMessage({ id: 'emptyBmiParticipatedList' }));
      } finally {
        setLoading(false);
      }
    };

    fetchList();
  }, [filters.institution_id, filters.grade, filters.section_id, filters.round, filters.academic_year, filters.shift_id, intl]);

  const meta = {
    title: intl.formatMessage({ id: 'bmiParticipatedList' }),
    className: filters.className || (filters.grade ? `${intl.formatMessage({ id: 'class' })} ${filters.grade}` : '-'),
    sectionName: filters.sectionName || '-',
    year: filters.academic_year || '-',
    round: filters.round || '-',
  };

  return (
    <React.Fragment>
      <BreadCrumb />
      {loading && <LoadingSpinner />}
      {!loading && error && (
        <section className='mx-auto bg-white py-4 lg:py-10'>
          <p className='text-center text-red-600'>{error}</p>
        </section>
      )}
      {!loading && !error && students.length === 0 && (
        <section className='mx-auto bg-white py-4 lg:py-10'>
          <p className='text-center text-gray-500'>{intl.formatMessage({ id: 'emptyBmiParticipatedList' })}</p>
        </section>
      )}
      {!loading && students.length > 0 && (
        <section className='mx-auto bg-white py-4 lg:py-10 space-y-4'>
          <PDFViewer style={viewerStyle.viewer}>
            <BmiListPdfFile students={students} meta={meta} isBn={isBn} intl={intl} />
          </PDFViewer>
        </section>
      )}
    </React.Fragment>
  );
};

export default BmiListPdfDocument;
